/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 * Modal auto report creating.
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import { ImgStatusSuccess } from '@components/common/Block/Img';
import { ICommonTranslation } from '@modules/internationalization/types';
import { IWizardAdditionalReportsTranslation } from '@modules/internationalization/types/wizards/additionalReports';
import Modal from '@modules/modal/components/Modal';
import { IModalPopup } from '@modules/modal/components/ModalPopup';
import { ModalCenterStyled } from '@modules/modal/components/styled/ModalCenterStyled';
import { CLIENT_ID, RoutePath } from '@routes/constants/routesConstants';

import { Button, LinkBlock } from '../../../components/common';

interface IWizardAdditionalReportsAutoReportResultModal {
    onCloseButtonClick: () => void;
    autoReportId?: number | string;
    autoReportType: string;
    translation: IWizardAdditionalReportsTranslation;
    translationCommon: ICommonTranslation;
}

type TWizardAdditionalReportsAutoReportResultModal =
    IWizardAdditionalReportsAutoReportResultModal & Pick<IModalPopup, 'onCloseModal' | 'dataName'>;

export const WizardAdditionalReportsAutoReportResultModal = (props: TWizardAdditionalReportsAutoReportResultModal) => {
    const {
        autoReportId,
        autoReportType,
        dataName,
        translation,
        translationCommon,
        onCloseButtonClick,
        onCloseModal,
    } = props;

    return (
        <Modal dataName={dataName} width="590px">
            <ModalCenterStyled>
                <ImgStatusSuccess />
                <Modal.Title>
                    {translation.wizardSummary.orderMessageStart}&nbsp;
                    <br />
                    {autoReportId ? (
                        <LinkBlock url={RoutePath.autoReportId.replace(CLIENT_ID, String(autoReportId))}>
                            {autoReportType || autoReportId}
                        </LinkBlock>
                    ) : (
                        autoReportType
                    )}
                    <br />
                    {translation.wizardSummary.orderMessageEnd}
                </Modal.Title>
                <Modal.Text>
                    {translation.wizardSummary.details}&nbsp;
                    <LinkBlock url={RoutePath.orders}>«{translationCommon.pages.historyOrder}»</LinkBlock>
                </Modal.Text>
                <Modal.Control>
                    <Button dataName="modal-order-ok" kind="medium" onClick={onCloseButtonClick || onCloseModal}>
                        {translationCommon.modal.good}
                    </Button>
                </Modal.Control>
            </ModalCenterStyled>
        </Modal>
    );
};

export default WizardAdditionalReportsAutoReportResultModal;
